import {LitElement, html} from 'lit';
class WJPackageConditions extends LitElement {
  data = null;
  packageTemplate = null;

  static get properties() {
    return {
      conditions: {
        type: Object,
      },
    };
  }
  render() {
    return html`<span>Conidition</span> `;
  }
}
const initWJPackageConditions = () => {
  window.customElements.define('wj-package-conditions', WJPackageConditions);
};

export {initWJPackageConditions};
